// Compare two changelog versions like "v1.0.2". Non-numeric segments (e.g. the
// "—" placeholder used for Incoming-only changelogs) sort lowest. Returns a
// positive number when `a` is newer than `b`, negative when older, 0 if equal.
export function compareVersions(a?: string, b?: string): number {
  const parse = (v?: string): number[] =>
    (v ?? '')
      .replace(/^v/i, '')
      .split('.')
      .map((n) => parseInt(n, 10))
      .map((n) => (Number.isNaN(n) ? -1 : n));
  const pa = parse(a);
  const pb = parse(b);
  const len = Math.max(pa.length, pb.length);
  for (let i = 0; i < len; i++) {
    const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
}
